import { IonListHeader } from '@ionic/react';
import { ReactElement } from 'react';
import { IntercomArticle } from '../../../config/intercom';
import i18n from '../../../i18n';
import { IntercomHelp } from '../../help/intercom-help';
import {
  AddScratchpadToPlaylist,
  CreateNewPlaylistWithScratchpad,
} from '../scratchpad/scratchpad-item-detail';
import { useScratchpadServiceContext } from '../scratchpad/scratchpad-service-context-provider';
import { ScratchpadAlreadyInPlaylist } from './scratchpad-already-in-playlist';
import { useScratchpadPlaylistHelpers } from './scratchpad-playlist.hooks';

interface ScratchpadPlaylistOptionsProps {
  onAction?: () => void;
  header?: ReactElement;
}

const ScratchpadPlaylistOptions = (
  props: ScratchpadPlaylistOptionsProps
): ReactElement => {
  const { onAction } = props;
  const { scratchpad } = useScratchpadServiceContext();

  const { addScratchpadToActivatedPlaylist, createNewPlaylistWithScratchpad } =
    useScratchpadPlaylistHelpers({
      machineId: scratchpad?.machineId,
    });

  const header = props.header ?? (
    <div className="playlist-options-header">
      <IonListHeader>
        {i18n.t('common:scratchpad_playlist_options')}
      </IonListHeader>
      <IntercomHelp articleId={IntercomArticle.PLAYLIST_OVERVIEW} />
    </div>
  );

  return (
    <div style={{ paddingBottom: 10 }}>
      {header}
      <ScratchpadAlreadyInPlaylist scratchpadId={scratchpad.id} />
      <AddScratchpadToPlaylist
        scratchpad={scratchpad}
        onSelect={async () => {
          await addScratchpadToActivatedPlaylist(
            scratchpad.id,
            {},
            {
              fromShortcutMenu: true,
            }
          );
          if (onAction) {
            onAction();
          }
        }}
      />
      <CreateNewPlaylistWithScratchpad
        scratchpad={scratchpad}
        onSelect={async () => {
          if (scratchpad) {
            await createNewPlaylistWithScratchpad(scratchpad, {
              fromShortcutMenu: true,
            });
          }
          if (onAction) {
            onAction();
          }
        }}
      />
    </div>
  );
};

export { ScratchpadPlaylistOptions };
